/**
 * User
 * This is a wrapper component for Material-UI's `Avatar` providing a simple size attribute to
 * adjust the size of the image. Currently only one additional size is necessary based on the
 * design documentation.
 */
import { styled } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import React from 'react';
import defaultMuiTheme from '../../theme/mui-config/default';
const LargeAvatar = styled(Avatar)({
    height: defaultMuiTheme.spacing(12),
    width: defaultMuiTheme.spacing(12),
    fontSize: defaultMuiTheme.spacing(6),
});
const User = props => {
    const { size, ...rest } = props;
    return size === 'large' ? React.createElement(LargeAvatar, Object.assign({}, rest)) : React.createElement(Avatar, Object.assign({}, rest));
};
export default User;
//# sourceMappingURL=User.js.map